import { useQuery } from "@tanstack/react-query";
import { type ApiClient, useApiClient } from "../context/ApiClientProvider";
import { LysaCountry } from "../countries/constants";

export interface OpeningHours {
  openingTime: string;
  closingTime: string;
}

export interface TwilioIntegrationResponse {
  defaultOpeningHours: OpeningHours;
}

/**
 * Formats a time string by removing seconds (HH:MM:SS → HH:MM)
 * If the string doesn't contain seconds, returns it unchanged
 */
const formatTimeString = (timeString: string): string => {
  const timeParts = timeString.split(":");
  if (timeParts.length >= 2) {
    return timeParts.slice(0, 2).join(":");
  }
  return timeString;
};

const baseUrl = "/phone/opening-hours/";

const dataTwilioIntegration = {
  getActiveOpenHours: (country: LysaCountry, API: ApiClient) => {
    return API.get<TwilioIntegrationResponse>(
      `${baseUrl}active?country=${country}`,
      true,
    );
  },
};

export const useGetActiveOpenHours = (country: LysaCountry) => {
  const API = useApiClient();

  return useQuery<TwilioIntegrationResponse, Error, OpeningHours>({
    queryKey: ["active-open-hours", country],
    queryFn: () => dataTwilioIntegration.getActiveOpenHours(country, API),
    select: (data) => {
      const { openingTime, closingTime } = data.defaultOpeningHours;
      return {
        openingTime: formatTimeString(openingTime),
        closingTime: formatTimeString(closingTime),
      };
    },
  });
};
